<div>
  <div data-testid="notification-controls" class="notification-controls">
    <div class="notification-controls-start">
      <dx-radio-group data-testid="notification-filter" class="notification-filter" [dataSource]="filterOptions"
        layout="horizontal" [value]="selectedFilter()" (onValueChanged)="onFilterChange($event)" />
      <dx-check-box [value]="selectAllChecked()" [text]="selectAllChecked() ? 'Deselect All' : 'Select All'"
        (click)="onSelectAllChange()" />
    </div>
    <div class="notification-controls-inner">
      <dx-text-box name="search" class="search-box" placeholder="Search" [showClearButton]="true"
        valueChangeEvent="input" [value]="searchTerm()" (onValueChanged)="onSearchTermChange($event)">
        <dxi-text-box-button name="clear" />
      </dx-text-box>
      <dx-button stylingMode="outlined" [text]="'Mark ' + selectedItems().length + ' as Read'"
        type="danger" [width]="150" [disabled]="!hasSelectedItems()" (click)="markAsRead(selectedItems())" />
    </div>
  </div>
  <div data-testid="notifications-container" class="notifications-container">
    @for(notification of notifications(); track notification.id) {
    <div class="notification-card" [class.notification-card-read]="notification.isRead"
      [attr.data-read]="notification.isRead">
      <div class="notification-check-box">
        @if(!notification.isRead) {
        <dx-check-box [value]="isItemSelected(notification.id)"
          (onValueChanged)="onItemSelectionChange(notification.id, $event)">
        </dx-check-box>
        }
      </div>
      <div class="notiication-content">
        <div class="notification-header">
          <div class="notification-title-row">
            <div class="notification-title">{{ notification.title }} - {{ notification.taskName }}</div>
            <span class="notification-status" [class.notification-status-unread]="!notification.isRead">
              {{ notification.isRead ? 'Read' : 'Unread' }}
            </span>
          </div>
        </div>

        <div class="notification-meta">
          <div class="notification-task" *ngIf="notification.taskName">
            <strong>Time:</strong> {{ notification.updatedTimestamp | date:'short' }}
          </div>
          <div class="notification-sender">
            <strong>From:</strong> {{ notification.sender }}
          </div>
        </div>

        <div class="notification-body">
          {{ notification.body }}
        </div>
      </div>
      <div class="notification-actions">
        @if(!notification.isRead) {
        <dx-button stylingMode="contained" text="Mark as Read" type="danger" [width]="150"
          (click)="markAsRead([notification.id])" />
        }
        <dx-button stylingMode="contained" text="View Task" type="normal" [width]="150"
          (click)="openLink(notification)" />
      </div>
    </div>
    } @empty {
    @if(!isLoading() && !initialising() ) {
    <div class="no-notifications">
      No Notifications Found
    </div>
    }
    }
  </div>
  @if(totalNotifications() > 0) {
  <div data-testid="notification-pagination" class="notification-pagination">
    <dx-pagination [showInfo]="true" [showNavigationButtons]="true" [itemCount]="totalNotifications()"
      [pageIndex]="pageIndex()" [allowedPageSizes]="pageSizeOptions" [pageSize]="pageSize()"
      (pageSizeChange)="onPageSizeChange($event)" (pageIndexChange)="onPageIndexChange($event)" />
  </div>
  }
</div>


<dx-load-panel data-testid="notification-load-panel" container=".notifications-container"
  [position]="{ of: '.notifications-container' }" [visible]="isLoading() || isUpdating()" [showPane]="true" width="100"
  height="100" />